import { useParams } from 'react-router';
import { odoslanaPripomienkaExists } from '../client/odoslanaPripomienkaExists';
import { useClientFetch } from '../context/ClientStatusContext';
import ClassType from '../model/pripomienka/ClassType';
import PripomienkyListFilter from '../model/filter/PripomienkyListFilter';

interface ReturnType {
  odoslanaPripExists: boolean;
}

export default (
  classType: ClassType,
  pripomienkaFilter: PripomienkyListFilter,
  isEnabled: boolean,
  fetchOdoslanaExists:boolean,
): ReturnType => {
  // @ts-ignore
  const { type, year, index } = useParams<{ type: string, year: number, index: number }>();
  const {
    data: odoslanaPripomienkaExistsStatus,
  } = useClientFetch(
    isEnabled ? odoslanaPripomienkaExists : undefined,
    isEnabled ? [classType, type, year, index, pripomienkaFilter] : [],
    [fetchOdoslanaExists],
  );
  // Compared against the raw wire value, not OdoslanaPripomienkaStatusEnum's generated member
  // name - openapi-generator's prefix-stripping for this enum's member names is not stable
  // across generation runs (has flipped between `Exists` and `PripomienkaExists`).
  const odoslanaPripExists = odoslanaPripomienkaExistsStatus === 'PRIPOMIENKA_EXISTS';
  return {
    odoslanaPripExists,
  };
};
